/**Class that maange a cascade dropdown events
 * The flow is the following:
 * contructor
 * 1. Define the defaultResetAction with some code. ie clear any validation message
 * 2. Add events in the right order with addEvent. event=the onchange event from the dropdown, reset=code to clear selected and avaliable options from the dropdown
 *
 * on dropdown change
 * 1. Call resetDependencies
 * 2. Load options from the next dropdown
 * 3. Call runNextDependendentEvent
 * 
 */
export class CascadeManager {
  /**
   * Costructor
   * @param component The component instace instance. ie this
   * @example this
   */
  constructor(private component:any) {

  }
  private events: CascadeManagerEvent[] = [];
  /** Function that will run when all dropdowns are cleared by calling resetDependencies */
  defaultResetAction: () => void;

  /**
   * run the reset events from all dropdowns after  currentEvent
   * @param currentEvent The current event being fired
   */
  resetDependencies(currentEvent:any) {
    var runItem = false;
    for (let item of this.events) {
      if (item.event == currentEvent) {
        runItem = true;
        continue;
      }

      if (runItem) {
        this.defaultResetAction?.call(this.component);
        item.reset.call(this.component);
      }
    }
  }

  /**
   * Add one event to the list. Events needs to be added in the cascading order
   * @param event
   */
  addEvent(event: CascadeManagerEvent) {
    this.events.push(event);
  }


  /**Manually run the first event*/
  runFirstEvent() {
    this.events[ 0 ].event.call(this.component);
  }

/**
 * Trigger the next event in the list after currentEvent
 * @param currentEvent The current event being fired
 * @returns
 */
  runNextDependendentEvent(currentEvent:any) {
    var runItem = false;
    for (let item of this.events) {
      if (item.event == currentEvent) {
        runItem = true;
        continue;
      }

      if (runItem) {
        if(item && item.event) {
          item.event.call(this.component);
        }
        return;
      }
    }

    console.warn("No next event found.");
  }
}


/** The event dto. Represents a dropdown event and what todo when it needs to be cleared*/
export class CascadeManagerEvent {
  /**The event the dropdown is running during the change or onSelect event*/
  event: any;
  /** Function that will run when the dropdown is cleared*/
  reset: () => void;
}
